import { Grid } from "@mui/material";
import styled from "styled-components";

export const StyledGrid = styled(Grid)`
  ${({ theme }) => `
    @media screen and (min-width: ${theme.breakpoints.xxs}) {
      &:nth-child(n+3){
        display: none;
      }
    }
    @media screen and (min-width: ${theme.breakpoints.md}) {
      &:nth-child(3){
        display: block;
      }
    }
    @media screen and (min-width: ${theme.breakpoints.lg}) {
      &:nth-child(4){
        display: block;
      }
    }
  `}
`;
